<template>
  <div class="hp-banner">
    <img
      :src="require('@/assets/Presentation.png')"
      alt="Hot Pursuit — poursuite en ville"
      class="hp-banner-img"
      loading="eager" />
    <div class="hp-banner-overlay">
      <h1 class="hp-banner-title">HOT PURSUIT</h1>
      <span class="hp-banner-sub">Club Baby Pro</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HotPursuitBackGround'
  };
</script>

<style scoped>
  .hp-banner {
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid var(--border);
  }
  .hp-banner-img {
    display: block;
    width: 100%;
    height: clamp(220px, 42vw, 520px);
    object-fit: cover;
  }
  .hp-banner-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: clamp(1.5rem, 5vw, 4rem);
    background: linear-gradient(to top, rgba(10, 14, 22, 0.9) 0%, rgba(10, 14, 22, 0.15) 55%, transparent 100%);
  }
  .hp-banner-title {
    font-family: 'fightt', sans-serif;
    font-size: clamp(2.5rem, 9vw, 6rem);
    margin: 0;
    color: #fff;
    text-shadow: 0 4px 30px rgba(0, 0, 0, 0.6), 0 0 40px rgba(34, 197, 94, 0.35);
    letter-spacing: 2px;
  }
  .hp-banner-sub {
    font-family: 'agency', sans-serif;
    text-transform: uppercase;
    letter-spacing: 5px;
    color: var(--gold);
    font-size: clamp(0.9rem, 2vw, 1.3rem);
  }
</style>
